export const CommentState = Object.freeze({
  PRESENT: 1,
  DELETED_BY_USER: 11,
  DELETED_BY_ADMIN: 12,
});

export const CommentStateOptions = [
  { label: "표시", value: CommentState.PRESENT },
  { label: "사용자가 삭제", value: CommentState.DELETED_BY_USER },
  { label: "운영자가 삭제", value: CommentState.DELETED_BY_ADMIN },
];
